module.exports = __webpack_public_path__ + "img/news-home-bg.770a24d7.jpg";